import React, { useEffect } from "react";

import MDAccordion from "../../../components/MDAccordion";

import Grid from "@mui/material/Grid";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import DeviceTable from "./DeviceTable";
import CostingTable from "./CostingTable";
import BillingTable from "./BillingTable";
import RefTable from "./RefTable";
import InfosTable from "./InfosTable";
import PreparationTable from "./PreparationTable";
import StageTable from "./StageTable";
import ContractTable from "./ContractTable";
import HoursTable from "./HoursTable";
import SafetyTable from "./SafetyTable";
import ComsTable from "./ComsTable";
import OrganismReserveTable from "./OrganismReserveTable";
import ClientReserveTable from "./ClientReserveTable";
import ControlTable from "./ControlTable";
import DeclarationTable from "./DeclarationTable";
import InternalTable from "./InternalTable";
import PpspsTable from "./PpspsTable";
import MadTable from "./MadTable";
import DoeTable from "./DoeTable";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";

export default function Device({ device, user }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <>
      <Divider
        style={{
          marginBottom: 0,
          background: darkMode ? "white" : "#344767",
        }}
      />
      <MDAccordion>
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon sx={{ color: darkMode ? "white !important" : "#344767 !important" }} />
          }
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }} variant="h5" fontWeight="bold">
            {device.device_number} {device.ot_number !== null ? "- " + device.ot_number : ""}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: "8px 4px" }}>
          <Grid container rowSpacing={6} columnSpacing={3}>
            <Grid container item rowSpacing={6} columnSpacing={3}>
              <Grid item container rowSpacing={6} lg={12} md={12} sm={12} xs={12}>
                <Grid item container xs={12}>
                  <DeviceTable user={user && user} device={device} />
                </Grid>
                <Grid item container xs={12}>
                  <CostingTable user={user && user} device={device} />
                </Grid>
              </Grid>
              {/* <Grid item container lg={3} md={12} sm={12} xs={12}>
                <HoursTable user={user && user} device={device} />
              </Grid> */}
            </Grid>
            <Grid container item rowSpacing={6} columnSpacing={3}>
              <Grid item container lg={5.5} md={12} sm={12} xs={12}>
                <BillingTable user={user && user} device={device} />
              </Grid>
              <Grid item container rowSpacing={6} lg={6.5} md={12} sm={12} xs={12}>
                <Grid item container xs={12}>
                  <RefTable user={user && user} device={device} />
                </Grid>
                <Grid item container xs={12}>
                  <InfosTable user={user && user} device={device} />
                </Grid>
              </Grid>
            </Grid>
            <PreparationTable user={user && user} device={device} />
            <StageTable user={user && user} device={device} />
            <Grid container item rowSpacing={6} columnSpacing={3}>
            <Grid
                item
                container
                rowSpacing={6}
                columnSpacing={3}
                lg={3.1}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "block" }}
              >
                <PpspsTable user={user && user} device={device} />
              </Grid>
              <Grid
                item
                container
                rowSpacing={6}
                columnSpacing={3}
                lg={3.6}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "block" }}
              >
                <SafetyTable user={user && user} device={device} />
              </Grid>
              <Grid item lg={1.7} md={12} sm={12} xs={12}>
                <InternalTable user={user && user} device={device} />
              </Grid>
              <Grid item lg={3.6} md={12} sm={12} xs={12}>
                <ContractTable user={user && user} device={device} />
              </Grid>
              {device.type === "Ascenseur" || device.type === "Ascenseur de charge" ? (
                <>
                  <Grid
                    item
                    container
                    rowSpacing={6}
                    columnSpacing={3}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "block" }}
                  >
                    <ControlTable user={user && user} device={device} />
                  </Grid>
                </>
              ) : (
                <></>
              )}
              <Grid
                item
                container
                rowSpacing={6}
                columnSpacing={3}
                lg={3.1}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "block" }}
              >
                <MadTable user={user && user} device={device} />
              </Grid>
              <Grid
                item
                container
                rowSpacing={6}
                columnSpacing={3}
                lg={3.1}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "block" }}
              >
                <DoeTable user={user && user} device={device} />
              </Grid>
            </Grid>
            {/* {(device.type === "Ascenseur" || device.type === "Ascenseur de charge") && (
              <OrganismReserveTable user={user && user} device={device} />
            )} */}
            <ClientReserveTable user={user && user} device={device} />
            <ComsTable user={user && user} device={device} />
          </Grid>
        </AccordionDetails>
      </MDAccordion>
    </>
  );
}